<template>
  <div style="width:100vw;height:100vh;">
    <head-nav-bar title="工作台" @click-left="toHome"> </head-nav-bar>
    <div class="rest-main">
      <div class="status-area">
        <span v-for="(item, index) in statusList" :key="index"
          ><i :style="{ background: item.color }"></i>{{ item.text }}
          {{ item.count }}</span
        >
      </div>
      <div class="table-wrap">
        <van-grid
          :gutter="5"
          :border="false"
          :column-num="3"
          class="table-list"
        >
          <van-grid-item v-for="(item, index) in tableList" :key="index">
            <div
              :class="['table-item', getFontColor(item.Color)]"
              :style="{ background: item.Color }"
              v-longpress="e => tableSetting(item)"
              @click="onTableClick(item)"
            >
              <div>
                <span>{{ item.TableCode }}</span>
                <span v-if="item.CheckInTime" class="check-in">
                  <van-icon name="clock-o" />
                  {{ item.CheckInTime }}
                </span>
              </div>
              <div>
                {{ item.TableName }}
                <small v-if="item.Contact">
                  <van-icon name="contact" /> {{ item.Contact }}
                </small>
              </div>
              <div>
                <span>
                  <van-tag
                    v-if="item.OrderStatusName == '点餐'"
                    type="success"
                    plain
                  >
                    {{ item.OrderStatusName }}
                  </van-tag>
                  <van-tag
                    v-if="item.OrderStatusName == '开台'"
                    type="primary"
                    plain
                  >
                    {{ item.OrderStatusName }}
                  </van-tag>
                  <van-tag color="#f50" v-if="item.HasUnconfirmedDish" plain>
                    待确认
                  </van-tag>
                </span>

                <span v-if="item.Fee">￥{{ item.Fee }}</span>
              </div>
            </div>
          </van-grid-item>
        </van-grid>
      </div>
    </div>

    <div class="footer">
      <van-dropdown-menu direction="up">
        <van-dropdown-item
          v-model="selectedMarket"
          :options="marketData"
          @change="changeMarket"
        />
      </van-dropdown-menu>
      <div class="summary-info">
        <span>总客数：{{ tableInfo.GuestNum }}</span>
        <span>上座率：{{ tableInfo.Attendance }}</span>
        <span>开台率：{{ tableInfo.UsingRate }}</span>
        <span> {{ tableInfo.AccountDate }}</span>
      </div>
    </div>
    <van-action-sheet
      v-model="show"
      :actions="actions"
      @select="onSelect"
      :round="false"
    />
  </div>
</template>
<script>
import {
  Button,
  Icon,
  Grid,
  GridItem,
  DropdownMenu,
  DropdownItem,
  Row,
  Col,
  Tag,
  Toast,
  ActionSheet,
} from "vant";
import { mapState } from "vuex";
import restaurantManageApi from "@/api/restaurantManage.js";
import { getSelectData } from "@/api/common.js";
import "@/utils/longpress";
export default {
  components: {
    [ActionSheet.name]: ActionSheet,
    [Tag.name]: Tag,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,

    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
  },
  data() {
    return {
      tableInfo: {},
      tableList: [],
      showForbiddens: false,
      show: false,
      selectTable: {},
      actions: [],
      keyword: "",
      marketData: [],
      selectedMarket: "",
      statusList: [],
    };
  },
  created() {},
  computed: {
    ...mapState({
      user: state => state.user.info,
    }),
  },
  mounted() {
    this.getSelectData();
    this.getTableInfo();
  },
  methods: {
    getSelectData() {
      getSelectData({
        Types: "RestaurantMarket",
      }).then(res => {
        this.selectedMarket = res.Data.RestaurantMarket.find(
          el => el.IsSelected,
        ).Id;
        this.marketData = res.Data.RestaurantMarket.map(v => {
          return {
            text: v.Text,
            value: v.Id,
          };
        });
      });
    },
    getTableInfo() {
      const { keyword, showForbiddens } = this;
      restaurantManageApi
        .getTableStatus({ Keyword: keyword, ShowForbiddens: showForbiddens })
        .then(res => {
          this.tableInfo = res.Data;
          this.tableList = res.Data.TableStatusDetails;
          const { tableInfo } = this;
          const totalAll =
            tableInfo.Occupy + tableInfo.EmptyClean + tableInfo.EmptyDirty;
          this.statusList = [
            {
              color: "url(/image/colorall.png)",
              text: "全部",
              count: totalAll,
            },
            {
              color: tableInfo.OccupyColor,
              text: "在用",
              count: tableInfo.Occupy,
            },
            {
              color: tableInfo.EmptyCleanColor,
              text: "空净",
              count: tableInfo.EmptyClean,
            },
            {
              color: tableInfo.EmptyDirtyColor,
              text: "空脏",
              count: tableInfo.EmptyDirty,
            },
          ];
        });
    },
    changeMarket(Id) {
      restaurantManageApi.changeMarket({ Id: Id }).then(() => {
        this.selectedMarket = Id;
        this.getTableInfo();
      });
    },
    onSelect(item) {
      if (item.name == "多桌点餐") {
        this.show = false;
        this.$router.push({
          name: "restarantManageOrderFood",
          query: {
            orderId: this.selectTable.Id,
          },
        });
      } else if (item.name == "清理桌台") {
        restaurantManageApi
          .cleanTable({
            Id: this.selectTable.TableId,
          })
          .then(() => {
            Toast.success("操作成功");
            this.show = false;
            setTimeout(() => {
              this.getTableInfo();
            }, 500);
          });
      }
    },
    tableSetting(item) {
      let menu = [];
      // if (item.Status == 0) {
      //   menu.push({ name: "多桌点餐" });
      // }
      if (item.ClearStatus == 0) {
        menu.push({ name: "清理桌台" });
      }
      if (!menu.length) {
        return;
      }
      this.show = true;
      this.selectTable = item;
      this.actions = menu;
    },
    onTableClick(item) {
      if (item.Status == 1) {
        //开台
        this.$router.push({
          name: "restarantManageOpenTable",
          query: {
            tableId: item.TableId,
          },
        });
      } else if (item.Status == 0) {
        //点菜

        if (item.OrderStatusName == "开台") {
          this.$router.push({
            name: "restarantManageOrderFood",
            query: {
              orderId: item.OrderId,
              tableId: item.TableId,
            },
          });
        } else {
          this.$router.push({
            name: "restarantManageDetail",
            query: {
              orderId: item.OrderId,
              tableId: item.TableId,
            },
          });
        }
      }
    },
    // 16进制颜色值转RGB
    colorHextoColorRGB(colorHex) {
      // 16进制颜色值的正则
      const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
      // 把颜色值变成小写
      let color = colorHex.toLowerCase();
      if (reg.test(color)) {
        // 如果只有三位的值，需变成六位，如：#fff => #ffffff
        if (color.length === 4) {
          let colorNew = "#";
          for (let i = 1; i < 4; i += 1) {
            colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1));
          }
          color = colorNew;
        }
        // 处理六位的颜色值，转为RGB
        let colorChange = [];
        for (let i = 1; i < 7; i += 2) {
          colorChange.push(parseInt("0x" + color.slice(i, i + 2)));
        }
        return colorChange;
      } else {
        return color;
      }
    },
    getFontColor(color) {
      let RgbValueArry = "";
      if (color.indexOf("rgb") > -1) {
        const RgbValue = color.replace("rgb(", "").replace(")", "");
        RgbValueArry = RgbValue.split(",");
      } else {
        RgbValueArry = this.colorHextoColorRGB(color);
      }
      const grayLevel =
        RgbValueArry[0] * 0.299 +
        RgbValueArry[1] * 0.587 +
        RgbValueArry[2] * 0.114;
      if (grayLevel >= 192) {
        return "font-black";
      } else {
        return "font-withe";
      }
    },
    toHome() {
      this.$router.push({ name: "workplace" });
    },
  },
};
</script>
<style lang="less" scoped>
.rest-main {
  height: calc(100vh - 123px);
  box-sizing: border-box;
  .table-wrap {
    height: calc(100vh - 156px);
    background: #fafafa;
  }
  .table-list {
    max-height: calc(100vh - 166px);
    padding-bottom: 10px;
    padding-top: 5px;
    overflow-y: auto;
    background: #fafafa;
  }
  .status-area {
    padding: 10px;
    border-bottom: 1px solid #eee;
    & > span {
      margin-right: 25px;
      font-size: 12px;
      & > i {
        display: inline-block;
        width: 15px;
        height: 15px;
        position: relative;
        top: 5px;
        margin-right: 5px;
        border: 1px solid #555;
        vertical-align: 2px;
      }
    }
  }
  /deep/.van-grid-item__content {
    border: 1px solid #eee;
    padding: 0;
    height: 80px;
    .table-item {
      background: #fff;
      height: 80px;
      width: 100%;
      border-radius: 3px;
      text-align: center;
      padding: 5px;
      &.font-black {
        color: #333;
      }
      &.font-withe {
        color: #fff;
      }
      & > div {
        height: 25%;
        font-size: 12px;
        &:nth-child(2) {
          height: 50%;
          font-size: 16px;
          small {
            font-size: 12px;
            display: block;
          }
        }
        &:first-child,
        &:last-child {
          display: flex;
          justify-content: space-between;
        }
      }
    }
  }
}

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  border-top: 1px solid #ebedf0;
  box-sizing: border-box;

  .summary-info {
    background: #f4fdff;
    height: 26px;
    line-height: 26px;
    font-size: 12px;
    display: flex;
    justify-content: space-around;
  }
}
</style>
